"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const services_1 = require("@zapier/services");
const getNodeType_1 = __importDefault(require("./getNodeType"));
function getHeadAndTailServiceCTASteps({ flow, services, }) {
    const [headServiceNodeId, tailServiceNodeId] = lodash_1.keys(flow.nodes).map(lodash_1.toNumber);
    const headServiceNode = flow.nodes[headServiceNodeId];
    const headNodeType = getNodeType_1.default(headServiceNode);
    const headNodeAction = headServiceNode.action;
    const headService = services_1.getAssociatedService(headServiceNode, services);
    const tailServiceNode = flow.nodes[tailServiceNodeId];
    const tailNodeType = getNodeType_1.default(tailServiceNode);
    const tailNodeAction = tailServiceNode.action;
    const tailService = services_1.getAssociatedService(tailServiceNode, services);
    const headServiceActionNoun = headService
        ? services_1.actionNoun(headService, headNodeAction, headNodeType).toLowerCase()
        : '';
    const tailServiceActionNoun = tailService
        ? services_1.actionNoun(tailService, tailNodeAction, tailNodeType).toLowerCase()
        : '';
    return [
        {
            text: `1. Creating a new ${headServiceActionNoun} in`,
            serviceId: headService ? headService.id : '',
            serviceName: headService ? headService.name : '',
        },
        {
            text: `2. Look for a new ${tailServiceActionNoun} in`,
            serviceId: tailService ? tailService.id : '',
            serviceName: tailService ? tailService.name : '',
        },
    ];
}
exports.default = getHeadAndTailServiceCTASteps;
